import {Injectable} from '@angular/core';

import * as _ from 'lodash';

@Injectable()
export class SearchbarService {

  constructor() {
  }

  private _acc(tab) {
    var value = null;
    var retVal = {};
    if (tab.length > 1) {
      value = this._acc(_.tail(tab));
    } else {
      return tab[0];
    }
    retVal[tab[0]] = value;
    return retVal;
  }

  private _parseFilter(filter) {
    var newFilter = {all: []};
    filter = filter.split('\"');
    if (filter.length >= 3) {
      filter = _.map(filter, (e, i) => {
        if ((i % 2) && i != filter.length - 1) {
          return e.toString().split(' ').join('');
        } else {
          return e;
        }
      });
    }
    filter = filter.join('').split(' ');
    filter.forEach(entry => {
      entry = entry.split(':');
      if (entry.length == 1) {
        newFilter.all.push(entry[0]);
      }
      else {
        newFilter = _.merge(newFilter, this._acc(entry));
      }
    });
    return newFilter;
  }

  private _filterObject(h, v, tmpRes, toIgnore) {
    _.forOwn(h, (hVal, hKey) => {
      if (toIgnore.indexOf(hKey.toString()) >= 0 || tmpRes) {
        return;
      }
      else if (typeof(hVal) === 'object') {
        tmpRes = this._filterObject(hVal, v, tmpRes, toIgnore);
      } else {
        tmpRes = (hVal != null && hVal != undefined) ? (hVal.toString().split(' ').join('').search(new RegExp(v, 'i')) >= 0) : false;
      }
    });
    return tmpRes;
  }

  filter(collection, filter, toIgnore?) {
    if (!toIgnore) {
      toIgnore = [];
    }
    toIgnore.push('_id');
    toIgnore.push('__v');
    if (!filter) {
      collection.display = collection.all;
      return;
    }
    filter = this._parseFilter(filter);
    collection.display = _.filter(collection.all, (h) => {
      var result = true;
      _.forOwn(filter, (val, key) => {
        if (!result) {
          return;
        }
        if (key == 'all') {
          val.forEach(v => {
            if (!result) {
              return;
            }
            var tmpRes = false;
            tmpRes = this._filterObject(h, v, tmpRes, toIgnore);
            result = tmpRes;
          })
        } else if (h.hasOwnProperty(key)) {
          var tmp = h;
          while (typeof(val) != 'string' && val != null
          && h.hasOwnProperty(key)) {
            var valKeys = _.keys(val);
            val = val[valKeys[0]];
            h = h[key];
            key = valKeys[0];
          }
          result = h.hasOwnProperty(key) && (h[key].toString().split(' ').join('').search(new RegExp(val, 'i')) >= 0);
          h = tmp;
        } else {
          result = false;
        }
      });
      return result;
    });
  }
}
